import socketIOClient from "socket.io-client";
import config from "../../config/index";
import { onBlindSpotRepeat, onBlindSpotRepeatFailure } from "./blindSpotRepeat";
import { onAssessmentCancelled } from "./cancelled";
import { onAssessmentComplete } from "./completed";
import { onAssessmentReportConnect } from "./connect";
import { onProcessedDataDisconnect } from "./disconnect";
import { onHmdAutoPause } from "./hmdAutoPause";
import { onPauseAssessment } from "./pauseAssessment";
import { onPauseStatusesFromDevice } from "./pauseStatusesFromDevice";
import { onProcessedDataUpdate } from "./processDataUpdate";
import { onResumeAssessment } from "./resumeAssessment";
import { onWarningStatusesFromDevice } from "./warningStatusesFromDevice";
import { onBlindspotTest } from "./blindspotTest";
import { onAssessmentStartVFT } from "./startVFT";
import { onProcessedSummaryDataUpdate } from "./processSummaryUpdate";
// import { onBlindSpotRepeatCompleted } from "./blindSpotRepeatCompleted";

export const connectAssessmentNamespaceSocket = (assessmentId) => {
    const socketConnectUrl = config.CONSTANTS.ASSESSMENTS_SOCKET_URL
    const socket = socketIOClient(socketConnectUrl, { transports: ['websocket'] })

    socket.on("connect", () => onAssessmentReportConnect(socket, assessmentId))

    socket.on("blindspotFailure", data => onBlindSpotRepeatFailure(data))

    socket.on("blindspotRepeatYes", data => onBlindSpotRepeat(data))
    socket.on("blindspotRepeatNo", data => onBlindSpotRepeat(data))

    // socket.on("DEVICE_MISMATCH", data => onDeviceMismatch(data))

    socket.on("assessmentPaused", data => onPauseAssessment(data))

    socket.on("assessmentResumed", data => onResumeAssessment(data))

    socket.on("startVFT", data => onAssessmentStartVFT(data, assessmentId))

    socket.on("blindspotTest", data => onBlindspotTest(data, assessmentId))

    socket.on("processedDataUpdated", data => onProcessedDataUpdate(data, assessmentId))

    socket.on("summary", data => onProcessedSummaryDataUpdate(data, assessmentId))

    socket.on('completed', data => onAssessmentComplete(data))

    socket.on('disconnect', reason => onProcessedDataDisconnect(reason))

    socket.on('cancelled', reason => onAssessmentCancelled(reason))

    socket.on('hmdAutoPause', reason => onHmdAutoPause(reason))

    socket.on('pauseStatusesFromDevice', reason => onPauseStatusesFromDevice(reason))

    socket.on('warningStatusesFromDevice', reason => onWarningStatusesFromDevice(reason))

    return socket
}
